import { InformationIcon } from "@/assets/icons";
import Divider from "@/components/ui/Divider";
import Dropdown from "@/components/ui/dropdown";
import { IOptionItem } from "@/components/ui/dropdown/types";
import Tooltip from "@/components/ui/tooltip";
import { MESSAGE } from "@/constants/message";
import { SpatialAggregationType } from "@/types/common";
import { H3Configuration } from "@/types/dataset";
import { EOutputAnalysisType } from "@/types/spatial";

type AggregationFilterProps = {
  spatialType?: SpatialAggregationType;
  value?: H3Configuration | null;
  dataSource?: string;
  onChangeAggregationType: (value: string) => void;
};

const AGGREGATION_OPTIONS = [
  {
    value: "AVG",
    label: "AVG"
  }
];

const AggregationFilter = ({
  spatialType,
  value,
  dataSource = "bvt",
  onChangeAggregationType
}: AggregationFilterProps) => {
  const handleChangeAggregationType = (option: IOptionItem | null) => {
    if (!option) return;
    onChangeAggregationType(option.value);
  };

  if (spatialType !== EOutputAnalysisType.H3 || dataSource !== "bvt") return;

  const aggregation =
    AGGREGATION_OPTIONS.find((item) => item.value === value?.aggregationType) ??
    AGGREGATION_OPTIONS[0]; // Default to AVG if not found

  return (
    <>
      <Divider className="my-3" />
      <div className="flex flex-col gap-3">
        <div className="flex justify-between items-center">
          <label htmlFor="aggregation" className="text-sm font-semibold">
            Aggregation
          </label>
          <Tooltip
            content={MESSAGE.AGGREGATION_INFO_TOOLTIP}
            className="max-w-[190px]"
            position="top-right"
            arrowPadding={16}
          >
            <button
              type="button"
              aria-label="Aggregation Info"
              className="bg-transparent border-0 p-0"
            >
              <InformationIcon title="Aggregation Info" />
            </button>
          </Tooltip>
        </div>
        <Dropdown
          name="aggregation"
          showLabelOnTop={false}
          placeholder="Aggregation"
          data={AGGREGATION_OPTIONS}
          value={aggregation}
          onSelect={handleChangeAggregationType}
        />
      </div>
    </>
  );
};

export default AggregationFilter;
